// extracted by mini-css-extract-plugin
export default {"wce":"wce","wce_iframe":"wce_iframe","edit":"edit"};